import React from 'react';

const UsersTable = ({
  users = [],
  loading = false,
  onStatusChange,
  onResetPassword,
  onView,
}) => {
  if (loading) {
    return <div className="admin-table-message">Loading users...</div>;
  }

  if (users.length === 0) {
    return (
      <div className="admin-table-message">
        <h3>No distributor users found</h3>
        <p>Create a user account for a firm to get started.</p>
      </div>
    );
  }

  return (
    <div className="admin-table-wrapper">
      <table className="admin-table">
        <thead>
          <tr>
            <th>User</th>
            <th>Username</th>
            <th>Firm ID</th>
            <th>Role</th>
            <th>Status</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {users.map((user) => {
            const active = user.is_active === true;

            return (
              <tr key={user.id}>
                <td>
                  <div className="admin-table-primary">{user.name}</div>
                  <div className="admin-table-secondary">
                    ID: {user.id}
                  </div>
                </td>

                <td>{user.username}</td>
                <td>{user.firm_id ?? '—'}</td>
                <td>
                  <span className="admin-role-badge">
                    {user.role}
                  </span>
                </td>

                <td>
                  <span
                    className={`admin-status ${
                      active ? 'active' : 'inactive'
                    }`}
                  >
                    {active ? 'Active' : 'Inactive'}
                  </span>
                </td>

                <td>
                  {user.created_at
                    ? new Date(user.created_at).toLocaleDateString()
                    : '—'}
                </td>

                <td>
                  <div className="admin-table-actions">
                    {onView && (
                      <button
                        type="button"
                        className="admin-button admin-button-secondary"
                        onClick={() => onView(user)}
                      >
                        View
                      </button>
                    )}

                    {user.role === 'distributor' && onResetPassword && (
                      <button
                        type="button"
                        className="admin-button admin-button-secondary"
                        onClick={() => onResetPassword(user)}
                      >
                        Reset Password
                      </button>
                    )}

                    {user.role === 'distributor' && onStatusChange && (
                      <button
                        type="button"
                        className={`admin-button ${
                          active
                            ? 'admin-button-danger'
                            : 'admin-button-success'
                        }`}
                        onClick={() => onStatusChange(user, !active)}
                      >
                        {active ? 'Deactivate' : 'Activate'}
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default UsersTable;